import React, { useEffect, useState } from 'react'
import { dropDownApis, TODAY_DATE } from 'Common/Constants'
import CustomInput from 'Common/CustomInput'
import CustomTextarea from 'Common/CustomTextArea'
import ReactPortal from 'Components/ReactPortal/ReactPortal'

import Validator, { ValidationTypes as V_Type, } from "react-form-supervalidator";
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage'
import api from 'http'
import FullPageLoader from 'Components/FullPageLoader/FullPageLoader'
import TaskLinkPopup from './TaskLinkPopup'
import TaskSelectBox from 'MainTabs/Tasks/TaskComponents/TaskSelectBox'
import TaskLinksBox from 'MainTabs/Tasks/TaskComponents/TaskLinksBox'
import TaskAssigneeBox from 'MainTabs/Tasks/TaskComponents/TaskAssigneeBox'
import TaskLinkTypePopup from 'MainTabs/Tasks/Taskpopups/TaskLinkTypePopup'
import { toast } from 'react-toastify'
import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew'
import AsyncSelect from 'Common/AsyncSelect/AsyncSelect'
import useDataFetch from 'Common/useDataFetch/useDataFetch'
import CustomSelect from 'Common/CustomSelect/CustomSelect'
import { TASK_CREATED_SUCCESSFULLY } from 'Common/ToastConstants'

const formatStatusLabel = (d) => {
    const parts = d.label.split(":");
    return parts[1] ? parts[1] : parts[0];
}
const formatParentTaskLabel = (d) => {
    return `${d.id ? `(${d.id})` : ""} ${d.label.slice(0, 50)}${d.label.length > 50 ? "..." : ""}`;
}
const CreateTaskPopup = ({ onClose, patientInfo, claimInfo }) => {
    // if patientInfo is coming then it means , this is comming from patient
    const [tagsList, setTagsList] = useState([])
    const [searchModel, setSearchModel] = useState({
        "practiceId": 0,
        "addedBy": "",
        "inActive": false,
        "id": 0,
        "name": "",
        "description": "",
        "type": "Single",
        dueDate: TODAY_DATE,
        "parentTaskId": 0,
        "taskTypeId": "",
        "statusId": 2,
        "priorityId": 0,
        "externalUrl": "",
        "url": "",
        taskTags: [],
        taskLinkTo: [],
        "taskAssignees": [],

    })
    const [addLinkPopup, setAddLinkPopup] = useState(false)
    const [createTaskModal, setCreateTaskModal] = useState({ status: false, data: { linkTypeId: 0, type: "" } })
    const [validationModel, setValidationModel] = useState({
        taskTypeIdError: null,
        taskLinkToError: null,
        taskAssigneesError: null,
        descriptionError: null,
        nameError: null,
        dueDateError: null
    })
    const [tagLoader, setTagLoader] = useState(false)


    const { data: FindTaskPriority } = useDataFetch(dropDownApis.task.findTaskPriority, 'findTaskPriority')
    const { data: FindTaskStatus } = useDataFetch(dropDownApis.task.findTaskStatus, 'findTaskStatus')

    const handleChange = (e) => {
        setSearchModel((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }))
    }

    const setValidation = () => {
        let validationObj = {
            ...validationModel,
            taskTypeIdError: Validator(searchModel.taskTypeId, [V_Type.required], ['Category is required'],),
            taskLinkToError: Validator(searchModel.taskLinkTo, [V_Type.required], ['Minimum one Link is required'],),
            taskAssigneesError: Validator(searchModel.taskAssignees, [V_Type.required], ['Minimum one Assignee is required'],),
            descriptionError: Validator(searchModel.description, [V_Type.required], ['Description is required'],),
            nameError: Validator(searchModel.name, [V_Type.required], ['Title is required'],),
            dueDateError: Validator(searchModel.dueDate, [V_Type.required], ['Due Date is required'],),
        }
        setValidationModel(validationObj)
        return Validator(validationObj, V_Type.NullCheck);
    }

    const handleTagChange = (tags) => {
        setSearchModel((prev) => ({ ...prev, taskTags: tags }))
    }
    const handleTagListChange = (list) => {
        setTagsList(list)
    }

    // ************************* AddTaskLinkPopup Function Start******************
    const openAddLinkPopup = () => {
        if (searchModel.taskLinkTo.length > 0) {
            setCreateTaskModal({ status: true, data: createTaskModal.data })
        }
        else {
            setAddLinkPopup(true)
        }
    }
    const closeAddLinkPopup = (linkTypeId, type) => {
        if (linkTypeId) setCreateTaskModal({ status: true, data: { linkTypeId, type } })
        setAddLinkPopup(false)
    }
    // ************************* AddTaskLinkPopup Function End ******************


    // **************************** SelectTaskPopup Funtions Start ***********************
    const closeSelectTaskPopup = () => {
        if (searchModel.taskLinkTo.length > 0) {
            setCreateTaskModal((prev) => ({
                ...prev,
                status: false,
            }))
        }
        else {
            setCreateTaskModal({ status: false, data: { linkTypeId: 0, type: "" } })
        }
    }
    const onChangeLink = (links) => {
        let taskType = links.length > 1 ? "Bulk" : "Single"
        setSearchModel((prev) => ({
            ...prev,
            taskLinkTo: links,
            type: taskType
        }))
        setValidationModel((prev) => ({ ...prev, taskLinkToError: null }))
        setCreateTaskModal((prev) => ({
            ...prev,
            status: false,
        }))
    }

    // **************************** SelectTaskPopup Funtions End ***********************

    const handleRemoveLink = (link) => {
        const updatedLinks = searchModel.taskLinkTo.filter((tl) => tl.description !== link.description)

        let taskType = updatedLinks.length > 1 ? "Bulk" : "Single"
        if (updatedLinks.length === 0) {
            setCreateTaskModal({ status: false, data: { linkTypeId: 0, type: "" } })
        }
        setSearchModel((prev) => ({ ...prev, taskLinkTo: updatedLinks, type: taskType }))
    }



    //  ********************* TaskAssignee Funtion Start **********************
    const handleChangeAssignee = (assignees) => {
        setSearchModel((prev) => ({ ...prev, taskAssignees: assignees }))
        if (assignees.length > 0) setValidationModel((prev) => ({ ...prev, taskAssigneesError: null }))

    }

    //  ********************* TaskAssignee Funtion End **********************

    const onSave = async () => {
        let myValidation = setValidation();
        if (myValidation) {

        } else {

            try {
                setTagLoader(true)
                await api.post(`${process.env.REACT_APP_TC_TASK}/api/Task/SaveTask`, searchModel)
                toast.success(TASK_CREATED_SUCCESSFULLY)
                onClose(true)
            } catch (error) {
                ErrorHandlingMessage(error)
            } finally { setTagLoader(false) }
        }
    }

    useEffect(() => {
        if (!FindTaskPriority || !FindTaskStatus) return
        (async () => {
            try {
                setTagLoader(true)
                const response = await api.get(`${process.env.REACT_APP_TC_TASK}/api/DropDown/FindTag`)
                setTagsList(response.data.dataModel)
                let taskLinkToArray = []
                let taskType = "Single"
                let statusId = FindTaskStatus[1].id
                let priorityId = FindTaskPriority[2].id
                if (patientInfo || claimInfo) {
                    let linkTypeObj = { linkTypeId: 0, type: "" }
                    let linkObj = {
                        "addedBy": "",
                        "inActive": false,
                        "taskId": 0,
                        "id": 0,
                        description: "",
                        "paymentMainId": 0,
                        claimId: 0,
                        patientId: 0
                    }
                    let linkTypeResp = await api.get(`${process.env.REACT_APP_TC_TASK}/api/DropDown/FindTaskLinkType`)
                    if (patientInfo) {
                        const patientLink = linkTypeResp.data.dataModel.find((t) => t.label === "Patient")
                        linkTypeObj = { linkTypeId: patientLink.value, type: patientLink.label }
                        patientInfo.forEach((patient) => {
                            taskLinkToArray.push({
                                ...linkObj,
                                linkTypeId: linkTypeObj.linkTypeId,
                                type: linkTypeObj.type,
                                description: `${patient.patientName} Account# (${patient.accountNum})`,
                                patientId: patient.patientId
                            })
                        })
                        taskType = patientInfo.length > 1 ? "Bulk" : "Single"

                    } else if (claimInfo) {
                        const claimLink = linkTypeResp.data.dataModel.find((t) => t.label === "Claim")
                        linkTypeObj = { linkTypeId: claimLink.value, type: claimLink.label }
                        claimInfo.forEach((claim) => {
                            taskLinkToArray.push({
                                ...linkObj,
                                linkTypeId: linkTypeObj.linkTypeId,
                                type: linkTypeObj.type,
                                description: `Claim(#${claim.visitId}) Follow up for ${claim.patientName}`,
                                claimId: claim.visitId
                            })
                        })
                        taskType = claimInfo.length > 1 ? "Bulk" : "Single"
                    }
                    setCreateTaskModal((prev) => ({
                        ...prev,
                        status: false,
                        data: linkTypeObj
                    }))
                }
                setSearchModel((prev) => ({
                    ...prev,
                    taskLinkTo: taskLinkToArray,
                    type: taskType,
                    statusId: statusId,
                    priorityId: priorityId
                }))
            } catch (error) {
                ErrorHandlingMessage(error)
            }
            finally {
                setTagLoader(false)
            }
        })();
    }, [patientInfo, claimInfo, FindTaskStatus, FindTaskPriority])

    return (
        <>
            {tagLoader && <FullPageLoader allowFullScreen />}
            {addLinkPopup && <TaskLinkTypePopup onClose={closeAddLinkPopup} />}
            {createTaskModal.status && <TaskLinkPopup onClose={closeSelectTaskPopup} allLinks={searchModel.taskLinkTo} linkType={createTaskModal.data} onChangeLink={onChangeLink} />}
            <ReactPortal wrapperId="CreateTaskPopup  ">
                <div data-te-modal-init className="fixed left-0 top-0 z-[10] h-full w-full overflow-y-auto overflow-x-hidden outline-none" id="exampleModalScrollable" tabIndex={-1} aria-labelledby="exampleModalScrollableLabel" style={{ display: 'block' }} aria-modal="true" role="dialog" data-te-open="true">
                    <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
                    <div data-te-modal-dialog-ref className="pointer-events-none flex items-center relative h-[calc(100%-1rem)] w-auto translate-y-[-50px] transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] transform-none opacity-100">
                        <div className="pointer-events-auto p-10 relative flex gap-y-5 justify-between max-h-[100%] w-full flex-col overflow-hidden rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none dark:bg-neutral-600">
                            <div className='text-2xl font-semibold border-b '>Create Task</div>
                            {/* <div >    </div> */}
                            <div className="relative overflow-y-auto">
                                <div className='grid grid-cols-12 gap-4 py-3'>
                                    <div className='col-span-12'>
                                        <CustomInput onChange={handleChange} required name="name" toLower value={searchModel.name} label="Task Title" />
                                        {validationModel.nameError}
                                    </div>
                                    <div className='col-span-12'>
                                        <AsyncSelect
                                            onChange={handleChange} name="taskTypeId" value={searchModel.taskTypeId} label="Category" required
                                            apiLink={`${process.env.REACT_APP_TC_TASK}/api/DropDown/FindTaskType`}
                                        />
                                        {validationModel.taskTypeIdError}
                                    </div>
                                    <div className='col-span-4'>
                                        <CustomInput onChange={handleChange} required name="dueDate" min={TODAY_DATE} value={searchModel.dueDate} label="Due Date" type="date" />
                                        {validationModel.dueDateError}
                                    </div>
                                    <div className='col-span-4'>
                                        <AsyncSelect
                                            onChange={handleChange} name="statusId" value={searchModel.statusId} label="Status"
                                            apiLink={`${process.env.REACT_APP_TC_TASK}/api/DropDown/FindTaskStatus`}
                                            formatLabel={formatStatusLabel}
                                        />

                                    </div>
                                    <div className='col-span-4'>
                                        <AsyncSelect
                                            onChange={handleChange} name="priorityId" value={searchModel.priorityId} label="Priority"
                                            apiLink={`${process.env.REACT_APP_TC_TASK}/api/DropDown/FindTaskPriority`}
                                        />
                                    </div>

                                    <div className='col-span-4'>
                                        <CustomSelect disabled onChange={handleChange} name="type" value={searchModel.type} label="Task Type" >
                                            <option value="Single">Single</option>
                                            <option value="Bulk">Bulk</option>
                                        </CustomSelect>
                                    </div>
                                    <div className='col-span-4'>
                                        <CustomInput toLower onChange={handleChange} name="externalUrl" type="url" value={searchModel.externalUrl} label="External URL" />
                                    </div>
                                    <div className='col-span-4'>
                                        <AsyncSelect
                                            onChange={handleChange} name="parentTaskId" value={searchModel.parentTaskId} label="Parent Task"
                                            apiLink={`${process.env.REACT_APP_TC_TASK}/api/DropDown/FindTask`}
                                            formatLabel={formatParentTaskLabel}
                                        />

                                    </div>
                                    <div className='col-span-12'>
                                        <TaskSelectBox
                                            label="Tag"
                                            selectedTags={searchModel.taskTags}
                                            TagsList={tagsList}
                                            onChange={handleTagChange}
                                            onTagListChange={handleTagListChange}
                                        />

                                    </div>
                                    <div className='col-span-12'>
                                        <TaskLinksBox
                                            openAddLinkPopup={openAddLinkPopup}
                                            taskLinks={searchModel.taskLinkTo}
                                            handleRemoveLink={handleRemoveLink}
                                        />

                                        {validationModel.taskLinkToError}
                                    </div>
                                    <div className='col-span-12'>
                                        <TaskAssigneeBox
                                            allAssignees={searchModel.taskAssignees}
                                            handleChangeAssignee={handleChangeAssignee}
                                        />
                                        {validationModel.taskAssigneesError}
                                    </div>
                                    <div className='col-span-12'>
                                        <CustomTextarea
                                            name="description"
                                            value={searchModel.description}
                                            onChange={handleChange}
                                            label="Description"
                                            rows={4}
                                            maxWidth="100%"
                                            required
                                        />
                                        {validationModel.descriptionError}
                                    </div>

                                </div>
                            </div>
                            <div className="flex flex-wrap items-center justify-end flex-shrink-0 gap-2">
                                <CustomButtonNew label="Cancel" variant="outline" onClick={() => onClose(false)} />
                                <CustomButtonNew onClick={onSave} label="Save" />
                            </div>
                        </div>
                    </div>
                </div>

            </ReactPortal>
        </>

    )
}

export default CreateTaskPopup